import React from 'react'
import "./LandingPageSetupDetails.scss"

import { IBasicSetupDetails } from '../BasicSetupDetails/BasicSetupDetails';
import PageRedirectButton from 'components/CommunityOnboardingComp/SetupDetailsUtilities/PageRedirectButton';
import ProductTourVideo from 'components/CommunityOnboardingComp/SetupDetailsUtilities/ProductTourVideo';


const LandingPageSetupDetails: React.FC<IBasicSetupDetails> = ({
    subdomain, groupData, compSelected, description }
) => {
    const homepageUrl: string = "settings/landing-pages";
    const [isdisplayVideo, setDisplayVideo] = React.useState(false);

    return (
        <>
            {
                isdisplayVideo && (
                    <ProductTourVideo
                        isdisplayVideo={isdisplayVideo}
                        setDisplayVideo={setDisplayVideo}
                        videoId={1045163185}
                        sectionTitle="Watch how to create Landing Pages"
                    />
                )
            }
            <ul className='setup-details-items'>
                <span className='setup-details-items-span'>{description}</span>
                <li className='setup-detail'>
                    <div className="onboarding-message-content-container">
                        <div
                            className="onboarding-message-content"
                            onClick={() => setDisplayVideo(true)}
                        >
                            <img
                                className="onboarding-message-content-img"
                                src='https://static.group.app/assets/getting-started/Landing%20Page%20Builder%20-%209.png'
                                alt="Landing Pages"
                            />
                        </div>
                    </div>
                    <div className='setup-item-btn'>
                        <PageRedirectButton
                            url={homepageUrl}
                            subdomain={subdomain}
                            group={groupData}
                        />

                    </div>
                </li>
            </ul>

        </>
    )
}

export default LandingPageSetupDetails
